export const MachineLearningLabelOption: { [key: string]: string[] } = {
    "Data Anomaly Detection": [
        "Anomaly",
        "Regular"
    ]
}
